module.exports = __webpack_public_path__ + "img/icon-letter-j.72e29d1e.svg";